'use client'
import styles from './Banner.module.css'
import LinkButton, { LinkButtonKind, LinkButtonSize } from "@/components/UI/Buttons/LinkButton/LinkButton"
import { FEATURES } from '@/utils/constants'
import { getTranslations } from "next-intl/server"
import { useMemo } from 'react'
import { useDynamicSignUpURL } from "@/apiUtilities/queries/useDynamicSignUpURL"
import { useTranslations } from 'next-intl'

export default function Banner() {

	const t = useTranslations("FrontPage.Banner")
	const { data: dynamicSignUpURLData } = useDynamicSignUpURL({
		enabled: FEATURES.signUpExternal && FEATURES.signUpExternalDynamic
	})
	const signUpLink = useMemo(() => {
		if (!FEATURES.signUp) return '/login'
		if (!FEATURES.signUpExternal) return '/#plans'
		if (!FEATURES.signUpExternalDynamic) {
		return process.env.NEXT_PUBLIC_FEATURE_SIGNUP_EXTERNAL_LINK ?? ''
		}
		return dynamicSignUpURLData?.url || ''
	}, [dynamicSignUpURLData])
	return (
		<section id={'banner'} className={styles.main} data-scroll-section>
			<h1 className={styles.title}>
				{t('title', { siteName: process.env.NEXT_PUBLIC_SITENAME as string })}
			</h1>
			<p className={`bodyTextLarge ${styles.subtitle}`}>
				{t('subtitle')}
			</p>
			<LinkButton size={LinkButtonSize.LARGE} kind={LinkButtonKind.SUGGESTED} internal={true} href={signUpLink}>{t('buttonText')}</LinkButton>
			<div className={styles.bottomGradient}></div>
		</section>
	)
}